<template>
  <div id="exCenter" class="container">
    <h2>
      <span>“꿈을 체험하고 미래를 그리다”</span>
      <strong>
        한국잡월드
        <i>체험관</i>
      </strong>
    </h2>
    <div class="ec_list">
      <div>
        <router-link class="ec_child box_style01" :to="`/${currentRouteType}/child`">
          <dl>
            <dt>어린이체험관</dt>
            <dd>어린이 눈높이에 맞춘 직업테마놀이공간</dd>
          </dl>
        </router-link>
        <router-link class="ec_teen box_style01" :to="`/${currentRouteType}/teen`">
          <dl>
            <dt>청소년체험관</dt>
            <dd>실제현장과 유사하게 조성된 역할연기방식 직업체험 공간</dd>
          </dl>
        </router-link>
      </div>
      <div>
        <router-link class="ec_skill box_style02" :to="`/${currentRouteType}/skill`">
          <dl>
            <dt>숙련기술체험관</dt>
            <dd>3대숙련기술을 체험하는 k-skill 체험공간</dd>
          </dl>
        </router-link>
        <router-link class="ec_course box_style02" :to="`/${currentRouteType}/course`">
          <dl>
            <dt>진로설계관</dt>
            <dd>직업적성을 찾는 자기검사, 상담설계공간</dd>
          </dl>
        </router-link>
      </div>
      <!---->
      <div>
        <router-link class="ec_future box_style01" :to="`/${currentRouteType}/future`">
          <dl>
            <dt>미래직업관</dt>
            <dd>첨단기술을 경험하는 미래직업 방탈출과 자유로운 체험 공간</dd>
          </dl>
        </router-link>
      </div>
      <div>
        <router-link class="ec_makive box_style01" :to="`/${currentRouteType}/makive`">
          <dl>
            <dt>메카이브</dt>
            <dd>창작의 틀을 깨는 자유로운 미래형 만들기 체험관</dd>
            <dd>(C.라운지, M.스트리트, Y.클래스, K.그라운드)</dd>
          </dl>
        </router-link>
      </div>
      <!-- <div>
        <router-link class="ec_event box_style03" :to="`/${currentRouteType}/event`">
          <dl>
            <dt>이벤트/행사</dt>
            <dd>기획공연/교육문화/직업진로</dd>
          </dl>
        </router-link>
        <router-link class="ec_onjob box_style03" :to="`/${currentRouteType}/onJob`">
          <dl>
            <dt>ONJOB</dt>
            <dd>한국잡월드 직업·진로 프로그램</dd>
          </dl>
        </router-link>
      </div> -->
    </div>
    <!--// .ec_list-->
  </div>
</template>

<script>
export default {
  name: 'SubBranch',
  props: {},
  computed: {},
};
</script>

<style lang="scss" scoped></style>
